"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var CardSection_1 = require("./CardSection");
var Card = function (_a) {
    var active = _a.active, base = _a.base, children = _a.children, className = _a.className, dark = _a.dark, disabled = _a.disabled, href = _a.href, hoverable = _a.hoverable, _b = _a.el, el = _b === void 0 ? 'div' : _b, _c = _a.elevation, elevation = _c === void 0 ? 'flat' : _c, error = _a.error, light = _a.light, _d = _a.padding, padding = _d === void 0 ? 'default' : _d, placeholder = _a.placeholder, raised = _a.raised, thin = _a.thin, sharp = _a.sharp, status = _a.status, rest = __rest(_a, ["active", "base", "children", "className", "dark", "disabled", "href", "hoverable", "el", "elevation", "error", "light", "padding", "placeholder", "raised", "thin", "sharp", "status"]);
    var getElevation = function () {
        if (base)
            return 'base';
        if (raised)
            return 'raised';
        return elevation;
    };
    var getPadding = function () {
        if (thin)
            return 'thin';
        return padding;
    };
    var getStatus = function () {
        if (error)
            return 'error';
        if (active)
            return 'active';
        return status;
    };
    var CardClasses = classnames_1.default('Card', className, {
        'Card--base': getElevation() === 'base',
        'Card--raised': getElevation() === 'raised',
        'Card--thin': getPadding() === 'thin',
        'Card--no-padding': getPadding() === 'none',
        'Card--active': getStatus() === 'active',
        'Card--error': getStatus() === 'error',
        'Card--sharp': sharp,
        'Card--hoverable': hoverable || href || el === 'a' || rest.onClick,
        'Card--disabled': disabled,
        'Card--placeholder': placeholder,
        'Card--dark': dark,
        'Card--light': light,
    });
    var CardElement = href ? 'a' : el;
    return (react_1.default.createElement(CardElement, __assign({ className: CardClasses, href: href }, rest), utilities_1.wrapWithComponent(children, CardSection_1.CardSection)));
};
exports.Card = Card;
exports.Card.Section = CardSection_1.CardSection;
//# sourceMappingURL=Card.js.map